import * as React from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'

import NewFolderModal from 'modules/documents/components/Folders/NewFolderModal'
import { SPACE } from 'modules/documents/lib/constants'

interface CreateModalContext {
  parentRoute: string
  space: SPACE
  companyId: number
  parentFolderId?: number
  rootParentFolderId?: number
}

const NewFolderModalPage = () => {
  const navigate = useNavigate()
  const { parentRoute, space, companyId, parentFolderId, rootParentFolderId } =
    useOutletContext<CreateModalContext>()

  const onClose = () => navigate(parentRoute)

  return (
    <NewFolderModal
      onClose={onClose}
      space={space}
      companyId={companyId}
      parentFolderId={parentFolderId}
      rootParentFolderId={rootParentFolderId}
    />
  )
}

export default NewFolderModalPage
